import { createSlice } from '@reduxjs/toolkit';
import Common from '../../Common';

const initialState = {
    haveUnreadMessage: Number(Common.localStorageGetUnreadMessage() || 0),
    noticeDetail: null,
    noticeList: [],
};

export const noticeSlice = createSlice({
    name: 'notice',
    initialState,
    reducers: {
        setHaveUnreadMessage: (state, action) => {
            const value = Number(action.payload || 0);
            state.haveUnreadMessage = value;
            Common.localStorageSetUnreadMessage(value);
        },
        setNoticeDetail: (state, action) => {
            state.noticeDetail = {...action.payload};
        },
        clearNoticeDetail: (state) => {
            state.noticeDetail = null;
        },
        setNoticeList: (state, action) => {
            state.noticeList = action.payload || [];
        },
        markAllRead: (state) => {
            state.haveUnreadMessage = 0;
            Common.localStorageSetUnreadMessage(0);
        },
    },
});

export const {
    setHaveUnreadMessage,
    setNoticeDetail,
    clearNoticeDetail,
    setNoticeList,
    markAllRead,
} = noticeSlice.actions;

export default noticeSlice.reducer;
